import { render } from "./IconArrowCircle.vue?vue&type=template&id=f2244314&scoped=true"
import script from "./IconArrowCircle.vue?vue&type=script&lang=ts"
export * from "./IconArrowCircle.vue?vue&type=script&lang=ts"

import "./IconArrowCircle.vue?vue&type=style&index=0&id=f2244314&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f2244314"

export default script